import { useContext } from 'react';
import { useEntitySelection } from '@shared/api/providers/entitySelection';
import { Menu } from '@shared/components/Menu';
import type { Entity } from '@shared/data/entity';
import { i18n } from '@shared/util/i18n';
import { ChannelPermissionsContext } from '@shared/util/permissions';

interface Props {
  entity: Entity;
}

export function SelectMultipleMenuItem({ entity }: Props) {
  const { canUpdateCard } = useContext(ChannelPermissionsContext);
  const entitySelection = useEntitySelection();

  if (!canUpdateCard.enabled) {
    return null;
  }

  return (
    <Menu.Item
      label={i18n('card.menu.actions.selectMultiple')}
      onClick={() => entitySelection.addEntity(entity)}
    />
  );
}
